/**
 * src/core/lib/api/base.ts — single source of truth for the API base URL.
 *
 * PRI-271: drop the silent prod-routing-to-dev fallback. In dev/test the URL
 * defaults to dev-app.primateintelligence.ai (so local dev `npm run dev` Just Works).
 * In a production build with `VITE_API_BASE_URL` unset, this throws at module
 * load — catching the misconfiguration before the bundle ever ships.
 *
 * Components must import { API_BASE_URL } from this file. No more hardcoded
 * `https://dev-api.primateintelligence.ai` literals anywhere in src/.
 */

const ENV_BASE = import.meta.env.VITE_API_BASE_URL as string | undefined
const IS_PROD_BUILD = import.meta.env.PROD === true
const MODE = (import.meta.env.MODE as string | undefined) ?? 'development'

function resolveApiBaseUrl(): string {
  if (ENV_BASE && ENV_BASE.length > 0) {
    return ENV_BASE.replace(/\/+$/, '')
  }
  // Test environment: vitest sets MODE='test' and PROD=false. Use the dev URL
  // so existing tests that introspect the constant continue to work.
  if (!IS_PROD_BUILD || MODE === 'test') {
    return 'https://dev-api.primateintelligence.ai'
  }
  throw new Error(
    'VITE_API_BASE_URL is not set in the production build. Refusing to silently ' +
    'route prod traffic to dev. Set VITE_API_BASE_URL on the Vercel project.',
  )
}

export const API_BASE_URL = resolveApiBaseUrl()
